module.exports = __webpack_public_path__ + "img/icon-time-gift.00715480.png";